import { decode } from 'base-64';

export const tokenValidation = (token) => {
  let data = JSON.parse(decode(token.split('.')[1]));
  let result = {
    isValid: new Date() < new Date(data.exp * 1000),
    goTo: data.mode === 'user' ? '/login' : '/userLogin'
  };
  return result;
}